export default __webpack_public_path__ + "static/Clay-44609df23fc286575070f52cec5e50d2.png";